import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditPencil from '../../../../../Assets/StorefrontIcons/EditPencil.svg';
import ArrowUp from '../../../../../Assets/StorefrontIcons/ArrowUp.svg';
import { showToast } from '../../../../../Components/Toaster/Toaster';
import { moveSectionDown, moveSectionUp, removeSection, setCategoryToEdit, setSectionFormType, setSectionType } from '../../../../../Features/storefrontSlice';
import Delete from '../../../../../Assets/DeleteRed.svg';
import { getCachedMediaUrl } from '../../../../../lib/utils/utils';

function CategoryCard({ category }) {
    const [textSize, setTextSize] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);
    const [imageSize, setImageSize] = useState(0);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    useEffect(() => {
        setTextSize((zoomSize/100)*8);
        setLineHeight((zoomSize/100)*14);
        setImageSize((zoomSize/100)*44);
    }, [zoomSize]);

    return (
        <div className="px-1 flex flex-col items-center gap-1 shrink-0">
            <div style={{ width: `${imageSize}px`, height: `${imageSize}px` }} className="rounded-full overflow-hidden">
                <img className='size-full object-cover' src={category?.imageLink} alt={category.name} />
            </div>

            <p style={{ fontSize: `${textSize}px`, lineHeight: `${lineHeight}px` }} className='font-normal text-[#000000]'>{category.name}</p>
        </div>
    );
}

function CategorySectionDesktop({ item }) {
    const dispatch = useDispatch();
    const [buttonsVisible, setButtonsVisible] = useState(false);
    const [hoverOnBox, setHoverOnBox] = useState(false);

    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    const mobileItem = versionStack[versionIndex]?.versionData.find(section => section.item.name === item.item.name);

    const [textSize, setTextSize] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    useEffect(() => {
        setTextSize((zoomSize/100)*12);
        setLineHeight((zoomSize/100)*18);
    }, [zoomSize]);

    useEffect(() => {
        if(hoverOnBox) {
            setButtonsVisible(true);
        } else {
            setButtonsVisible(false);
        }
    }, [hoverOnBox]);

    function handleEditClick() {
        dispatch(setCategoryToEdit(item.item.id));
        dispatch(setSectionType('SECTION'));
        dispatch(setSectionFormType('CATEGORY_DESKTOP'));
    }
    
    function handleUpClick() {
        if(item.prev) {
            dispatch(moveSectionUp({ item, mobileItem }));
        }
        else {
            showToast('Action failed!', 'warning');
        }
    }

    function handleDownClick() {
        if(item.next) {
            dispatch(moveSectionDown({ item, mobileItem }));
        }
        else {
            showToast('Action failed!', 'warning');
        }
    }

    function handleDeleteClick() {
        dispatch(removeSection({ item, mobileItem }));
    }

    return (
        <div 
            onMouseEnter={() => setHoverOnBox(true)} 
            onMouseLeave={() => setHoverOnBox(false)} 
            className="w-full flex flex-col gap-3 relative"
        >
            {
                buttonsVisible && 
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 flex items-center rounded-md overflow-hidden bg-[#FFFFFF]">
                    <button onClick={handleEditClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={EditPencil} alt="" />
                    </button>
                    <button onClick={handleUpClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={ArrowUp} alt="" />
                    </button>
                    <button onClick={handleDownClick} className='outline-none size-8 flex items-center justify-center'>
                        <img className='rotate-180' src={ArrowUp} alt="" />
                    </button>
                    <button onClick={handleDeleteClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={Delete} alt="" />
                    </button>
                </div>
            }

            <p style={{ fontSize: `${textSize}px`, lineHeight: `${lineHeight}px` }} className='px-4 font-semibold text-[#000000]'>{item.item.name}</p>

            <div className="px-4 flex flex-nowrap gap-2 overflow-x-scroll no-scrollbar">
                {item.item.categoryLinkList.map(category => {
                    return (
                        <CategoryCard 
                            key={category.id} 
                            category={category} 
                        />
                    );
                })}
            </div>
        </div>
    );
}

export default CategorySectionDesktop;
